import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MainHeader } from '@app/shared/components/header/main-header/main-header';


@Component({
  selector: 'app-main-layout',
  imports: [CommonModule, RouterOutlet, MainHeader],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export class MainLayout {}
